// @flow
import styled from "styled-components"

export const SocialLoginWrap = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 38.2rem;
  margin: 0 auto;
`



// WEBPACK FOOTER //
// ./src/components/SocialLogin/styled.js